import { forwardRef, Ref } from 'react';
import { ReactVirtualizedTimeline, ReactVirtualizedTimelineRef } from '@repo/atomic-components';
import { classNames } from 'primereact/utils';
import { useAppSelector, selectShowDateBar } from '@/store';

interface TimelineDatesProps {
  dates: string[];
  newEntryIndex: number | null;
  editEntryIndex: number | null;
  handleTimelineClick: (date: string) => void;
}

export const TimelineDates = forwardRef((props: TimelineDatesProps, ref: Ref<ReactVirtualizedTimelineRef>) => {
  const { dates, newEntryIndex, editEntryIndex, handleTimelineClick } = props;
  const showDateBar = useAppSelector(selectShowDateBar);
  if (!showDateBar) return <></>;
  return (
    <ReactVirtualizedTimeline
      ref={ref}
      dates={dates}
      onClick={handleTimelineClick}
      className={classNames({
        'pointer-events-none': newEntryIndex || editEntryIndex
      })}
    />
  );
});
